"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _web3Utils = _interopRequireDefault(require("web3-utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Contract = function Contract(web3, abi, address) {
  _classCallCheck(this, Contract);

  this.web3 = web3;
  this.address = _web3Utils["default"].toChecksumAddress(address);
  var contract = new web3.eth.Contract(abi, address);
  return new Proxy(this, {
    get: function get(target, key) {
      if (typeof target[key] !== "undefined") {
        return target[key];
      }

      return contract[key];
    }
  });
};

exports["default"] = Contract;